module.exports = __webpack_public_path__ + "img/rz2.e4ade8af.png";